<h4 class="re-container-with-margin re-mb-20 re-mt-60 md:re-mb-30 re-ml-20 md:re-ml-auto">
  {{ 'personaldata.banking.title' | translate }}
</h4>
<div class="re-container-with-margin re-mb-20 re-mt-20">
  <bdo-info-box [type]="'info'" data-qa="bankdata-disabled-hint">
    <span [innerHTML]="'personaldata.banking.disabledHint' | translate: { hrefSepaMandateForm: reBaseData.hrefSepaMandateForm }"></span>
  </bdo-info-box>
</div>
<!-- Changing bank data is temporarily disabled, see disabledHint above -->
<bdo-edit-card class="re-relative"
  [isEditable]="false"
  [disabled]="true"
  (edit)="toggleEdit()">
  @if (state === LoadingState.LOADING) {
    <bdo-loading></bdo-loading>
  }
  @if (!isInEditMode) {
    <div class="re-summary-row">
      <div>{{ 'personaldata.banking.type' | translate }}</div>
      <div data-qa="titleValue">
        {{ (bankData?.debit ? 'personaldata.banking.debit' : 'personaldata.banking.noDebit') | translate }}
      </div>
    </div>
    @if (bankData?.debit) {
      <div class="re-summary-row">
        <div>{{ 'address.personalInfo.name' | translate }}</div>
        <div>{{bankData.debit?.accountholder}}</div>
      </div>
      <div class="re-summary-row">
        <div>{{ 'banking.iban' | translate }}</div>
        <div>{{bankData.debit?.iban}}</div>
      </div>
      <div class="re-summary-row re-mb-0">
        <div>{{ 'personaldata.banking.bankname' | translate }}</div>
        <div>{{bankData.debit?.bankname}}</div>
      </div>
    } @else {
      <div class="re-mt-30">
        {{ 'personaldata.banking.sepaRecommandation' | translate }}
      </div>
    }
    @if (bankData?.debit?.iban !== bankData?.credit?.iban) {
      @if (!bankData?.credit) {
        <div class="re-mt-30">
          {{ 'personaldata.banking.manualCredit' | translate }}
        </div>
      } @else {
        <hr class="re-my-15 re-border-t re-border-monochrome-medium-light">
        <div class="bold re-mt-15 re-mb-15">{{ 'personaldata.banking.credit' | translate }}</div>
        <div class="re-summary-row">
          <div>{{ 'address.personalInfo.name' | translate }}</div>
          <div>{{bankData.credit?.accountholder}}</div>
        </div>
        <div class="re-summary-row">
          <div>{{ 'banking.iban' | translate }}</div>
          <div>{{bankData.credit?.iban}}</div>
        </div>
        <div class="re-summary-row re-mb-0">
          <div>{{ 'personaldata.banking.bankname' | translate }}</div>
          <div>{{bankData.credit?.bankname}}</div>
        </div>
      }
    }
  } @else {
    <bdo-personal-data-banking-form
      [formWithSepaBox]="!bankData?.debit"
      (editDone)="editBankDataDone($event)"
      (cancel)="toggleEdit()"
    ></bdo-personal-data-banking-form>
  }

</bdo-edit-card>
